import { render } from "./EntradaAlmacen.vue?vue&type=template&id=a381998c"
import script from "./EntradaAlmacen.vue?vue&type=script&lang=js"
export * from "./EntradaAlmacen.vue?vue&type=script&lang=js"

import "./EntradaAlmacen.vue?vue&type=style&index=0&id=a381998c&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__